/** Only the resource reporter owns same-origin Next scripts and stylesheets. */
export function staticAssetPath(source: string): string | null {
  try {
    const url = new URL(source, window.location.href);
    return url.origin === window.location.origin &&
      /^\/_next\/static\/.+\.(?:js|css)$/.test(url.pathname)
      ? url.pathname
      : null;
  } catch {
    return null;
  }
}
